// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetMobwebOnboardingsModel,
  IMappers,
  TGetMobwebOnboardingsResponse,
  TGetMobwebOnboardingsResponse_1,
  TGetMobwebOnboardingsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetMobwebOnboardingsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'mobile-app-onboarding',
  pathApi: '/v1/get-mobweb-onboardings/',
} as TGetMobwebOnboardingsModel;

export function createGetMobwebOnboardingsModel(): TGetMobwebOnboardingsModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetMobwebOnboardingsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetMobwebOnboardings<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetMobwebOnboardingsOptions<TResponse200, TResponse400>): Promise<
  TGetMobwebOnboardingsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetMobwebOnboardingsModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetMobwebOnboardingsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetMobwebOnboardingsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetMobwebOnboardingsResponse;
}
